
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
	var customFieldsRegisterPage = Flits.customFieldsRegisterPage = function() {
		Flits.customFieldsRegisterPage.settings = {};
		var settings = {};
		settings = Flits.extend(Flits.customFieldsRegisterPage.settings, settings);
		Flits.dispatchEvent('Flits:customFields:registerPage:settings:Loaded', {
			settings: settings
		});
		Flits.fileFieldReset = function(fileFieldSelector, errorMessage) {
			flitsSnackbar.show({
				text: errorMessage,
				pos: 'bottom-center',
				showAction: false,
				customClass: 'flits-alert-error'
			});
			fileFieldSelector.val(null);
			var $customerCustomFieldRow = fileFieldSelector.closest('.customer-custom-field-row');
			var noFileLabel = $customerCustomFieldRow.find('.file-name-label').attr('data-file-label');
			$customerCustomFieldRow.find('.file-name-label').html(noFileLabel);
			Flits.customFields.settings.buttonElement.prop('disabled', false);
			$customerCustomFieldRow.find('.file-upload-spinner').addClass('flits-hide')
		};
		Flits.registerPageFileUploadChangeEvent = function(selector) {
			var uploadedFile = selector[0].files[0];
			if(typeof uploadedFile == 'undefined') {
				return false
			}
			Flits.customFields.settings.buttonElement.prop('disabled', true);
			var $customerCustomFieldRow = selector.closest('.customer-custom-field-row');
			$customerCustomFieldRow.find('.file-upload-spinner').removeClass('flits-hide');
			$customerCustomFieldRow.find('.file-uploaded').addClass('flits-hide');
			if(uploadedFile.name == '') {
				Flits.fileFieldReset(selector, Flits.customFields.settings.fileTypeInvalidErrorMessage);
				return false
			} else {
				var validFileTypes = selector.attr('accept').split(',');
				if(Flits.inArray(uploadedFile.type, validFileTypes) == -1) {
					Flits.fileFieldReset(selector, Flits.customFields.settings.fileTypeInvalidErrorMessage);
					return false
				}
				if(uploadedFile.size > Flits.customFields.settings.fileUploadMaxSize) {
					Flits.fileFieldReset(selector, Flits.customFields.settings.fileSizeExceedErrorMessage);
					return false
				}
				var fileName = uploadedFile.name;
				if(fileName.length > 30) {
					fileName = fileName.substring(0, 15) + '..' + fileName.substr(fileName.lastIndexOf('.') - 3)
				}
				selector.closest('.customer-custom-field-row').find('.file-name-label').html(fileName)
			}
			var fileInputName = selector.attr('name');
			var formData = new FormData;
			formData.append('token', Flits.token);
			formData.append('request_id', Flits.generateRequestId());
			formData.append('field_unique_id', fileInputName);
			formData.append(fileInputName, uploadedFile);
			if(typeof selector.attr('data-val') != "undefined") {
				formData.append('field_prev_temp_file_name', JSON.parse(selector.attr('data-val')).new_value)
			}
			Flits.ajax({
				method: "POST",
				url: Flits.customFields.settings.tempFileUploadURL,
				data: formData,
				contentType: false,
				processData: false,
				success: resp => {
					Flits.customFields.settings.buttonElement.prop('disabled', false);
					if(resp.status) {
						var fileHistory = selector.attr('name') + '_history';
						var fileData = JSON.stringify(resp[fileHistory]);
						selector.attr('data-val', fileData);
						$customerCustomFieldRow.find('.file-upload-spinner').addClass('flits-hide');
						$customerCustomFieldRow.find('.file-uploaded').removeClass('flits-hide')
					} else {
						Flits.fileFieldReset(selector, resp.error);
						return false
					}
				},
				error: function(resp) {
					Flits.fileFieldReset(selector, resp.responseJSON.message);
					return false
				}
			})
		};
		Flits(document).on('click', Flits.customFields.settings.buttonElement, (function(event) {
			var custom_fields_data = {};
			if(Flits.getLocalStorage(Flits.customFields.settings.localStorageKeyName) == null || Flits.getLocalStorage(Flits.customFields.settings.localStorageKeyName) == undefined) {
				Flits.setLocalStorage(Flits.customFields.settings.localStorageKeyName, {});
				custom_fields_data = Flits.getLocalStorage(Flits.customFields.settings.localStorageKeyName)
			} else {
				custom_fields_data = Flits.getLocalStorage(Flits.customFields.settings.localStorageKeyName)
			}
			custom_fields_data['visited_path_history'] = [location.pathname];
			var userCustomFields = Flits.customFields.settings.userCustomFields;
			Flits.each(userCustomFields, (function(index, customField) {
				var fieldValue = '';
				var parentDiv = Flits("form[action='/account']").find('[data-field-unique-id="' + customField.unique_id + '"]');
				var fieldType = parentDiv.attr('data-field-type');
				switch(fieldType) {
					case 'file':
						var selector = parentDiv.find('.customer-custom-field-value-input');
						var selectorName = selector.attr('name');
						fieldValue = selector.attr('data-val');
						custom_fields_data[selectorName] = fieldValue;
						break;
					case 'date':
					case 'time':
						parentDiv.find('.customer-custom-field-value-input').each((function(index) {
							var selector = Flits(this);
							var selectorName = Flits(this).attr('name');
							fieldValue = selector.val() != null ? selector.val() : '';
							custom_fields_data[selectorName] = fieldValue
						}));
						break;
					default:
						var selector = parentDiv.find('.customer-custom-field-value-input');
						var selectorName = selector.attr('name');
						fieldValue = selector.val();
						custom_fields_data[selectorName] = fieldValue;
						break
				}
			}));
			Flits.setLocalStorage(Flits.customFields.settings.localStorageKeyName, custom_fields_data)
		}));
		Flits(document).on('input', '.customer-custom-field-value-input[type="text"]', (function(event) {
			Flits.regexValidateInputTextbox(Flits(this))
		}));
		Flits(document).on('change', '.customer-custom-field-value-input[type="file"]', (function(event) {
			event.preventDefault();
			Flits.registerPageFileUploadChangeEvent(Flits(this))
		}));
		Flits.getFieldAjax()
	};
	var customFieldsAccountPage = Flits.customFieldsAccountPage = function() {
		Flits.customFieldsAccountPage.settings = {};
		var settings = {};
		settings = Flits.extend(Flits.customFieldsAccountPage.settings, settings);
		Flits.dispatchEvent('Flits:customFields:accountPage:settings:Loaded', {
			settings: settings
		});
		Flits.getCustomerCustomFieldsValue = function() {
			var currentPage = window.location.pathname.split("/").pop();
			var lastProfileUpdated = Flits.getLocalStorage('lastProfileUpdatedAt');
			if(typeof lastProfileUpdated == 'undefined' || lastProfileUpdated == '') {
				lastProfileUpdated = Date.now();
				Flits.setLocalStorage('lastProfileUpdatedAt', lastProfileUpdated)
			}
			Flits.ajax({
				method: "GET",
				url: Flits.customFields.settings.getCustomFieldsWithValuesURL.replace('{{ customer_id }}', Flits.customer_id),
				data: {
					currentPage: currentPage,
					token: Flits.token,
					customer_hash: Flits.customerHash,
					lastProfileUpdated: lastProfileUpdated
				}
			}).done((function(resp) {
				if(resp.status) {
					Flits.customFields.settings.userCustomFields = resp.userCustomFields;
					Flits.customFields.settings.customerCustomFieldsValues = resp.customerCustomFieldsValues;
					Flits.IsModuleLoaded.Customer.CustomFields.Ajax = true;
					Flits.loadCustomFields()
				}
			}))
		};
		Flits.setCustomerCustomFieldsValue = function() {
			Flits(".customer-custom-field-row").each((function(index) {
				var $customerCustomFieldRow = Flits(this);
				var customerCustomFieldUniqueId = $customerCustomFieldRow.attr('data-field-unique-id');
				var customerCustomFieldValue = '';
				$customerCustomFieldRow.find('.customer-custom-field-description').addClass('flits-hide');
				$customerCustomFieldRow.find('.customer-custom-field-required-error-message').addClass('flits-hide');
				var customerCustomFieldsValues = Flits.customFields.settings.customerCustomFieldsValues;
				if(typeof customerCustomFieldsValues[customerCustomFieldUniqueId] !== 'undefined') {
					customerCustomFieldValue = customerCustomFieldsValues[customerCustomFieldUniqueId]
				}
				switch($customerCustomFieldRow.attr('data-field-type')) {
					case 'date':
						if(customerCustomFieldValue == '') {
							customerCustomFieldValue = '--'
						}
						var date = customerCustomFieldValue.split("-");
						$customerCustomFieldRow.find('.customer-custom-field-value-input.year option[value="' + date[0] + '"]').prop('selected', true);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.year option[value="' + date[0] + '"]').attr('selected', true);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.year').val(date[0]);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.month option[value="' + date[1] + '"]').prop('selected', true);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.month option[value="' + date[1] + '"]').attr('selected', true);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.month').val(date[1]);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.day option[value="' + date[2] + '"]').prop('selected', true);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.day option[value="' + date[2] + '"]').attr('selected', true);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.day').val(date[2]);
						break;
					case 'time':
						if(customerCustomFieldValue == '') {
							customerCustomFieldValue = ':'
						}
						var time = customerCustomFieldValue.split(":");
						$customerCustomFieldRow.find('.customer-custom-field-value-input.hour option[value="' + time[0] + '"]').prop('selected', true);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.hour option[value="' + time[0] + '"]').attr('selected', true);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.hour').val(time[0]);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.minute option[value="' + time[1] + '"]').prop('selected', true);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.minute option[value="' + time[1] + '"]').attr('selected', true);
						$customerCustomFieldRow.find('.customer-custom-field-value-input.minute').val(time[1]);
						break;
					case 'file':
						var noFileLabel = $customerCustomFieldRow.find('.file-name-label').attr('data-file-label');
						$customerCustomFieldRow.find('.file-name-label').attr('data-file-name', noFileLabel);
						$customerCustomFieldRow.find('.file-name-label').html(noFileLabel);
						$customerCustomFieldRow.find('.customer-custom-field-file-view').attr('data-file-path', '');
						$customerCustomFieldRow.find('.customer-custom-field-file-delete').addClass('flits-hide');
						$customerCustomFieldRow.find('.customer-custom-field-file-undo').addClass('flits-hide');
						if(customerCustomFieldValue == '') {
							$customerCustomFieldRow.find('.customer-custom-field-file-view').addClass('flits-hide')
						} else {
							var historyVariable = customerCustomFieldUniqueId + '_history';
							if(typeof customerCustomFieldsValues[historyVariable] !== 'undefined') {
								var historyData = customerCustomFieldsValues[historyVariable];
								if(typeof historyData[0] !== 'undefined' && typeof historyData[0]['original_file_name'] !== 'undefined') {
									var originalFileName = historyData[0]['original_file_name'];
									$customerCustomFieldRow.find('.file-name-label').html(originalFileName);
									$customerCustomFieldRow.find('.file-name-label').attr('data-file-name', originalFileName);
									$customerCustomFieldRow.find('.customer-custom-field-file-view').attr('data-file-path', customerCustomFieldValue)
								}
							}
							$customerCustomFieldRow.find('.customer-custom-field-file-view').removeClass('flits-hide');
							$customerCustomFieldRow.find('.customer-custom-field-value-input[type="hidden"]').val('uploaded')
						}
						$customerCustomFieldRow.find('.customer-custom-field-value-input').val(null);
						$customerCustomFieldRow.find('.custom-file-input .file-upload-button').addClass('flits-hide');
						break;
					default:
						$customerCustomFieldRow.find('.customer-custom-field-value-input').val(customerCustomFieldValue);
						break
				}
			}))
		};
		Flits.loadCustomFields = function() {
			if(Flits.IsModuleLoaded.Profile && Flits.IsModuleLoaded.Customer.Ajax && Flits.IsModuleLoaded.Customer.CustomFields.Ajax) {
				Flits.setCustomerCustomFieldsDeatils(true)
			}
		};
		Flits(document).on('Flits:myProfile:Loaded', (function() {
			Flits.IsModuleLoaded.Profile = true;
			Flits.loadCustomFields()
		}));
		Flits(document).on('Flits:customer:AjaxSuccessful', (function() {
			Flits.IsModuleLoaded.Customer.Ajax = true;
			Flits.loadCustomFields()
		}));
		Flits(document).on('Flits:myProfile:EditButtonClicked', (function() {
			Flits('.customer-custom-field-row').find('input, textarea, select').removeAttr('disabled');
			Flits('.customer-custom-field-row').find('input, textarea, select').removeAttr('readonly');
			Flits.editButtonClickEvent()
		}));
		Flits(document).on('Flits:myProfile:EditCancelButtonClicked', (function() {
			Flits('.customer-custom-field-row').find('input[type="file"]').attr('disabled', true);
			Flits.afterSaveOrEditCancelButtonClickEvent();
			Flits.setCustomFieldRowHeightForMobile()
		}));
		Flits.editButtonClickEvent = function() {
			Flits.onEditSetCustomerCustomFieldsValue();
			Flits.setCustomFieldRowHeightForMobile()
		};
		Flits.onEditSetCustomerCustomFieldsValue = function() {
			Flits(".customer-custom-field-row").each((function(index) {
				var $customerCustomFieldRow = Flits(this);
				var customerCustomFieldUniqueId = $customerCustomFieldRow.attr('data-field-unique-id');
				var customerCustomFieldValue = '';
				var customerCustomFieldsValues = Flits.customFields.settings.customerCustomFieldsValues;
				if(typeof customerCustomFieldsValues[customerCustomFieldUniqueId] !== 'undefined') {
					customerCustomFieldValue = customerCustomFieldsValues[customerCustomFieldUniqueId]
				}
				if($customerCustomFieldRow.find('.customer-custom-field-description-text').html() != '') {
					$customerCustomFieldRow.find('.customer-custom-field-description').removeClass('flits-hide')
				} else {
					$customerCustomFieldRow.find('.customer-custom-field-description').addClass('flits-hide')
				}
				switch($customerCustomFieldRow.attr('data-field-type')) {
					case 'file':
						if(customerCustomFieldValue != '') {
							$customerCustomFieldRow.find('.customer-custom-field-file-delete').removeClass('flits-hide');
							if($customerCustomFieldRow.attr('data-field-required') == 'required') {
								$customerCustomFieldRow.find('input[type!="hidden"]').removeAttr('required')
							}
							$customerCustomFieldRow.find('.customer-custom-field-value-input[type="hidden"]').val('uploaded');
							$customerCustomFieldRow.find('.customer-custom-field-description').addClass('flits-hide');
							$customerCustomFieldRow.find('.file-upload-button').addClass('flits-hide')
						} else {
							$customerCustomFieldRow.find('.file-upload-button').removeClass('flits-hide')
						}
						break;
					default:
						break
				}
			}))
		};
		Flits.setCustomFieldRowHeightForMobile = function() {
			if(Flits.customFields.settings.accountPageTemplate == 2) {
				Flits('.flits-mobile-view .customer-custom-field-row .flits-input-wrap').each((function(index) {
					var flitsInputWrapActualHeight;
					if(Flits(this).attr('data-actual-height')) {
						flitsInputWrapActualHeight = parseFloat(Flits(this).attr('data-actual-height'))
					} else {
						flitsInputWrapActualHeight = parseFloat(Flits(this).height());
						Flits(this).attr('data-actual-height', parseFloat(flitsInputWrapActualHeight))
					}
					var flitsInputWrapNewHeight = flitsInputWrapActualHeight;
					if(!Flits(this).find('.customer-custom-field-required-error-message').hasClass('flits-hide')) {
						flitsInputWrapNewHeight = flitsInputWrapNewHeight + parseFloat(Flits(this).find('.customer-custom-field-required-error-message').height())
					}
					if(!Flits(this).find('.customer-custom-field-description').hasClass('flits-hide')) {
						flitsInputWrapNewHeight = flitsInputWrapNewHeight + parseFloat(Flits(this).find('.customer-custom-field-description').height())
					}
					if(flitsInputWrapNewHeight >= flitsInputWrapActualHeight) {
						Flits(this).height(flitsInputWrapNewHeight)
					}
				}))
			}
		};
		Flits.afterSaveOrEditCancelButtonClickEvent = function() {
			Flits.setCustomerCustomFieldsValue()
		};
		Flits(document).on('click', '.customer-custom-field-file-delete', (function() {
			var $customerCustomFieldRow = Flits(this).closest('.customer-custom-field-row');
			Flits.setFileField($customerCustomFieldRow, 'delete')
		}));
		Flits(document).on('click', '.customer-custom-field-file-undo', (function() {
			var $customerCustomFieldRow = Flits(this).closest('.customer-custom-field-row');
			Flits.setFileField($customerCustomFieldRow, 'undo')
		}));
		Flits(document).on('click', '.customer-custom-field-file-view', (function() {
			var loader = '<style>.file-url-loader{height:20px;animation:.6s linear infinite spinner;cursor:pointer;text-align:center}</style><svg class="file-url-loader" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-loader"><line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line></svg>';
			Flits('.customer-custom-field-file-view svg').addClass('flits-hide');
			Flits(loader).insertBefore('.customer-custom-field-file-view svg');
			var filePath = Flits(this).attr('data-file-path');
			Flits.ajax({
				type: "GET",
				url: Flits.customFields.settings.viewFileURL,
				data: {
					'filePath': filePath,
					token: Flits.token
				},
				success: function(resp) {
					Flits('.customer-custom-field-file-view .file-url-loader').remove();
					Flits('.customer-custom-field-file-view svg').removeClass('flits-hide');
					if(resp.status) {
						window.open(resp.fileUrl, "_blank")
					} else {
						alert(resp.error)
					}
				}
			})
		}));
		Flits.setFileField = function($customerCustomFieldRow, action) {
			var affectedElements = ['.customer-custom-field-file-delete, .customer-custom-field-file-view', '.customer-custom-field-file-undo, .custom-file-input .file-upload-button'];
			var elementsShow = 0;
			var elementsHide = 1;
			var fileLabel = '';
			switch(action) {
				case 'delete':
					elementsShow = 1;
					elementsHide = 0;
					if($customerCustomFieldRow.attr('data-field-required') == 'required') {
						$customerCustomFieldRow.find('input[type!="hidden"]').attr('required', 'required')
					}
					$customerCustomFieldRow.find('.customer-custom-field-value-input[type="hidden"]').val('delete');
					if($customerCustomFieldRow.find('.customer-custom-field-description-text').html() != '') {
						$customerCustomFieldRow.find('.customer-custom-field-description').removeClass('flits-hide')
					}
					fileLabel = $customerCustomFieldRow.find('.file-name-label').attr('data-file-label');
					break;
				case 'undo':
					if($customerCustomFieldRow.attr('data-field-required') == 'required') {
						$customerCustomFieldRow.find('input[type!="hidden"]').removeAttr('required')
					}
					$customerCustomFieldRow.find('.customer-custom-field-value-input[type="hidden"]').val('uploaded');
					if($customerCustomFieldRow.find('.customer-custom-field-description-text').html() != '') {
						$customerCustomFieldRow.find('.customer-custom-field-description').addClass('flits-hide')
					}
					$customerCustomFieldRow.find('.customer-custom-field-value-input[type!="hidden"]').val(null);
					var noFileLabel = $customerCustomFieldRow.find('.file-name-label').attr('data-file-label');
					$customerCustomFieldRow.find('.file-name-label').html(noFileLabel);
					fileLabel = $customerCustomFieldRow.find('.file-name-label').attr('data-file-name');
					break;
				default:
					break
			}
			$customerCustomFieldRow.find('.file-name-label').html(fileLabel);
			$customerCustomFieldRow.find(affectedElements[elementsShow]).removeClass('flits-hide');
			$customerCustomFieldRow.find(affectedElements[elementsHide]).addClass('flits-hide')
		};
		Flits.profilePageFileUploadChangeEvent = function(selector) {
			var $customerCustomFieldRow = selector.closest('.customer-custom-field-row');
			var uploadedFile = selector[0].files[0];
			if(uploadedFile.name == '') {
				flitsSnackbar.show({
					text: Flits.customFields.settings.fileTypeInvalidErrorMessage,
					pos: 'bottom-center',
					showAction: false,
					customClass: 'flits-alert-error'
				});
				selector.val(null);
				var noFileLabel = $customerCustomFieldRow.find('.file-name-label').attr('data-file-label');
				$customerCustomFieldRow.find('.file-name-label').html(noFileLabel);
				return false
			} else {
				var validFileTypes = selector.attr('accept').split(',');
				if(Flits.inArray(uploadedFile.type, validFileTypes) == -1) {
					flitsSnackbar.show({
						text: Flits.customFields.settings.fileTypeInvalidErrorMessage,
						pos: 'bottom-center',
						showAction: false,
						customClass: 'flits-alert-error'
					});
					selector.val(null);
					var noFileLabel = $customerCustomFieldRow.find('.file-name-label').attr('data-file-label');
					$customerCustomFieldRow.find('.file-name-label').html(noFileLabel);
					return false
				}
				if(uploadedFile.size > Flits.customFields.settings.fileUploadMaxSize) {
					flitsSnackbar.show({
						text: Flits.customFields.settings.fileSizeExceedErrorMessage,
						pos: 'bottom-center',
						showAction: false,
						customClass: 'flits-alert-error'
					});
					selector.val(null);
					var noFileLabel = $customerCustomFieldRow.find('.file-name-label').attr('data-file-label');
					$customerCustomFieldRow.find('.file-name-label').html(noFileLabel);
					return false
				}
				if(selector.val() == '' && selector.attr('required') == 'required') {
					selector.closest('.customer-custom-field-row').find('.customer-custom-field-required-error-message').removeClass('flits-hide')
				} else {
					selector.closest('.customer-custom-field-row').find('.customer-custom-field-required-error-message').addClass('flits-hide')
				}
				var fileName = uploadedFile.name;
				if(fileName.length > 13) {
					fileName = fileName.substring(0, 4) + '..' + fileName.substr(fileName.lastIndexOf('.') - 3)
				}
				selector.closest('.customer-custom-field-row').find('.file-name-label').html(fileName)
			}
		};
		Flits(document).on('Flits:myProfile:Validate', (function() {
			Flits('.customer-custom-field-value-input[required="required"]').each((function(index) {
				if(Flits(this).is(":visible")) {
					var $customerCustomFieldRow = Flits(this).closest('.customer-custom-field-row');
					if(Flits(this).val() == '' || Flits(this).val() == null || typeof Flits(this).val() === 'undefined') {
						$customerCustomFieldRow.find('.customer-custom-field-required-error-message').removeClass('flits-hide');
						Flits.myProfile.settings.isValidRequest = false;
						return
					} else {
						$customerCustomFieldRow.find('.customer-custom-field-required-error-message').addClass('flits-hide')
					}
				}
			}));
			Flits.setCustomFieldRowHeightForMobile();
			Flits.dispatchEvent('Flits:customFields:CustomValidate')
		}));
		Flits(document).on('Flits:myProfile:ChangeCustomFieldsAjaxSettings', (function(event) {
			Flits.myProfile.settings.formData = new FormData;
			var formParams = event.detail.params;
			Flits.each(formParams, (function(key, input) {
				Flits.myProfile.settings.formData.append(input.name, input.value)
			}));
			Flits.myProfile.settings.formData.append('from_page', 'account');
			var formSelector = event.detail.formSelector;
			formSelector.find('.customer-custom-field-value-input[type="file"]').each((function(index) {
				var selector = Flits(this);
				var uploadedFile = selector[0].files[0];
				if(typeof uploadedFile !== 'undefined') {
					Flits.myProfile.settings.formData.append(selector.attr('name'), uploadedFile)
				}
			}));
			var ajaxSettings = event.detail.ajaxSettings;
			ajaxSettings.contentType = false;
			ajaxSettings.processData = false;
			ajaxSettings.data = Flits.myProfile.settings.formData
		}));
		Flits(document).on('Flits:myProfile:Updated', (function(event) {
			var resp = event.detail.resp;
			if(typeof resp.customerCustomFieldsValues !== 'undefined') {
				Flits.customFields.settings.customerCustomFieldsValues = resp.customerCustomFieldsValues
			}
			Flits.setLocalStorage('lastProfileUpdatedAt', Date.now());
			Flits.afterSaveOrEditCancelButtonClickEvent()
		}));
		Flits(document).on('input', '.customer-custom-field-value-input[type="text"]', (function(event) {
			Flits.regexValidateInputTextbox(Flits(this))
		}));
		Flits(document).on('change', '.customer-custom-field-value-input[type="file"]', (function(event) {
			Flits.profilePageFileUploadChangeEvent(Flits(this))
		}));
		Flits.getCustomerCustomFieldsValue()
	};
	Flits.extend({
		customFields: {
			settings: {
				asset: null,
				userCustomFields: null,
				customerCustomFieldsValues: null,
				themeStoreId: null,
				accountPageTemplate: null,
				htmlStructure: null,
				buttonElement: null,
				loadingHtml: `<style>.custom-fields-loading{height:20px;animation:.6s linear infinite spinner;cursor:pointer;margin:10px;text-align:center}@keyframes spinner{to{transform:rotate(360deg)}}</style><div class="custom-fields-loading"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-loader"><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/></svg></div>`,
				getAssetURL: Flits.base_url + "/custom-fields/get-asset",
				getCustomFieldsURL: Flits.base_url + '/custom-fields/get',
				tempFileUploadURL: Flits.base_url + '/custom-fields/upload-file',
				saveCustomFieldsValuesURL: Flits.base_url + '/{{ customer_id }}/custom-fields/save',
				getCustomFieldsWithValuesURL: Flits.base_url + '/{{ customer_id }}/custom-fields/get',
				viewFileURL: Flits.base_url + '/custom-fields/generate-file-url',
				fileUploadMaxSize: 1 * 1000000,
				fileTypeInvalidErrorMessage: Flits.t('Flits.locals.custom_fields.file_type_invalid_error_message', 'Please check file type and try again'),
				fileSizeExceedErrorMessage: Flits.t('Flits.locals.custom_fields.file_size_exceed_error_message', 'File size exceeds 1MB, please resize and upload'),
				localStorageKeyName: 'custom_fields_data'
			}
		},
		uuidv4: function() {
			"use strict";
			var t, e = new Uint8Array(16);

			function o() {
				if(!t && !(t = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
				return t(e)
			}
			var n = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

			function r(t) {
				return "string" == typeof t && n.test(t)
			}
			for(var i = [], u = 0; u < 256; ++u) i.push((u + 256).toString(16).substr(1));

			function generateUUIDv4(t, e, n) {
				var u = (t = t || {}).random || (t.rng || o)();
				if(u[6] = 15 & u[6] | 64, u[8] = 63 & u[8] | 128, e) {
					n = n || 0;
					for(var f = 0; f < 16; ++f) e[n + f] = u[f];
					return e
				}
				return function(t) {
					var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
						o = (i[t[e + 0]] + i[t[e + 1]] + i[t[e + 2]] + i[t[e + 3]] + "-" + i[t[e + 4]] + i[t[e + 5]] + "-" + i[t[e + 6]] + i[t[e + 7]] + "-" + i[t[e + 8]] + i[t[e + 9]] + "-" + i[t[e + 10]] + i[t[e + 11]] + i[t[e + 12]] + i[t[e + 13]] + i[t[e + 14]] + i[t[e + 15]]).toLowerCase();
					if(!r(o)) throw TypeError("Stringified UUID is invalid");
					return o
				}(u)
			}
			return generateUUIDv4()
		},
		generateRequestId: function() {
			return Flits.uuidv4()
		},
		getcustomFieldsAsset: function() {
			var getAssetAjaxData = {
				token: Flits.token
			};
			if(location.pathname == '/account/register') {
				getAssetAjaxData['from_page'] = 'register'
			} else {
				getAssetAjaxData['from_page'] = 'account'
			}
			if(typeof Shopify.theme !== 'undefined' && typeof Shopify.theme.theme_store_id !== 'undefined' && Shopify.theme.theme_store_id != null) {
				Flits.customFields.settings.themeStoreId = Shopify.theme.theme_store_id
			} else if(typeof Flits.accountSettings !== 'undefined' && typeof Flits.accountSettings.themeStoreId !== 'undefined' && Flits.accountSettings.themeStoreId != null) {
				Flits.customFields.settings.themeStoreId = Flits.accountSettings.themeStoreId
			}
			if(typeof Flits.accountSettings !== 'undefined' && typeof Flits.accountSettings.template !== 'undefined' && Flits.accountSettings.template != null) {
				Flits.customFields.settings.accountPageTemplate = Flits.accountSettings.template
			}
			Flits.dispatchEvent('Flits:customFields:BeforeGetAssetAjax');
			getAssetAjaxData['theme_store_id'] = Flits.customFields.settings.themeStoreId;
			getAssetAjaxData['account_page_template'] = Flits.customFields.settings.accountPageTemplate;
			Flits.ajax({
				method: "GET",
				url: Flits.customFields.settings.getAssetURL,
				data: getAssetAjaxData
			}).done((function(resp) {
				if(resp.status) {
					Flits.customFields.settings.asset = resp.asset;
					Flits.dispatchEvent('Flits:customFields:GetAsset:AjaxSuccessful');
					if(typeof Flits.customFields.settings.asset !== 'undefined' && Flits.customFields.settings.asset != null) {
						Flits.getScript(Flits.customFields.settings.asset).done((function(script, textStatus) {
							Flits.dispatchEvent('Flits:customFields:AssetLoaded')
						})).fail((function(jqxhr, settings, exception) {}))
					}
				} else {}
			}))
		},
		regexValidateInputTextbox: function(selector) {
			var value = selector.val();
			if(typeof selector.attr('data-type') !== 'undefined') {
				switch(selector.attr('data-type')) {
					case 'letters':
						var letters = value.replace(/[^a-zA-Z ]/g, "");
						selector.val(letters);
						break;
					case 'numbers':
						var numbers = value.replace(/[^0-9 ]/g, "");
						selector.val(numbers);
						break;
					default:
						break
				}
			}
		},
		setCustomFieldValueAjax: function() {
			var custom_fields_data = Flits.getLocalStorage(Flits.customFields.settings.localStorageKeyName);
			if(typeof custom_fields_data !== 'undefined' && custom_fields_data != null) {
				var visited_path_history = custom_fields_data['visited_path_history'];
				if(typeof visited_path_history !== 'undefined' && Flits.inArray('/account/register', visited_path_history) != -1) {
					if(location.pathname == '/challenge') {
						visited_path_history.push(location.pathname);
						custom_fields_data['visited_path_history'] = visited_path_history;
						Flits.setLocalStorage(Flits.customFields.settings.localStorageKeyName, custom_fields_data);
						return true
					}
					custom_fields_data['token'] = Flits.token;
					custom_fields_data['customer_hash'] = Flits.customerHash;
					custom_fields_data['from_page'] = 'register';
					if(Flits.customer_id != -1) {
						Flits.removeItemLocalStorage(Flits.customFields.settings.localStorageKeyName);
						Flits.ajax({
							method: "POST",
							url: Flits.customFields.settings.saveCustomFieldsValuesURL.replace('{{ customer_id }}', Flits.customer_id),
							data: custom_fields_data
						}).done((function(resp) {
							if(resp.status) {} else {}
						}))
					}
				}
			}
		},
		dateTimeOptionGenerate: function(start, end, elem) {
			for(i = start; i <= end; i++) {
				let opt = Flits('<option/>');
				let val = i < 10 ? '0' + i : i;
				opt.attr('value', val);
				opt.html(val);
				elem.append(opt)
			}
		},
		setCustomFieldsList: function(userCustomField, index) {
			if(Flits('.customer-custom-field-row[data-field-unique-id="' + userCustomField.unique_id + '"]').length >= 1) {
				return
			}
			var fieldType = userCustomField.type;
			if(typeof Flits.customFields.settings.htmlStructure[fieldType] === 'undefined') {
				return
			}
			Flits.dispatchEvent('Flits:customFields:BeforeFieldAppend', {
				index: index
			});
			userCustomField = Flits.customFields.settings.userCustomFields[index];
			var singleFieldHtmlData = Flits.customFields.settings.htmlStructure[fieldType]['fieldHTML'];
			Flits(singleFieldHtmlData).insertBefore(Flits.customFields.settings.buttonElement);
			var $customerCustomFieldRow = Flits(".customer-custom-field-row-clone").attr('data-field-unique-id', userCustomField.unique_id).attr('data-field-type', userCustomField.type);
			$customerCustomFieldRow.addClass('flits-hide');
			$customerCustomFieldRow.find('input, textarea, select').addClass('customer-custom-field-value-input');
			if(location.pathname == '/account') {
				if(Flits.accountSettings.template == 1) {
					$customerCustomFieldRow.find('input, textarea, select').prop('readonly', true);
					$customerCustomFieldRow.find('input[type="file"]').prop('disabled', true);
					$customerCustomFieldRow.find('select').prop('disabled', true)
				} else {
					$customerCustomFieldRow.find('input, textarea, select').prop('disabled', true)
				}
			}
			$customerCustomFieldRow.find('.customer-custom-field-title').html(userCustomField.title);
			switch(fieldType) {
				case 'date':
					var $daySelector = $customerCustomFieldRow.find('.customer-custom-field-value-input.day');
					$daySelector.attr('name', userCustomField.unique_id + "[day]");
					Flits.dateTimeOptionGenerate(1, 31, $daySelector);
					var $monthSelector = $customerCustomFieldRow.find('.customer-custom-field-value-input.month');
					$monthSelector.attr('name', userCustomField.unique_id + "[month]");
					Flits.dateTimeOptionGenerate(1, 12, $monthSelector);
					var $yearSelector = $customerCustomFieldRow.find('.customer-custom-field-value-input.year');
					$yearSelector.attr('name', userCustomField.unique_id + "[year]");
					Flits.dateTimeOptionGenerate(1920, (new Date).getFullYear(), $yearSelector);
					$customerCustomFieldRow.find('select.customer-custom-field-value-input option[value=""]').prop('selected', true);
					$customerCustomFieldRow.find('select.customer-custom-field-value-input option[value=""]').attr('selected', true);
					$customerCustomFieldRow.find('select.customer-custom-field-value-input').val('');
					break;
				case 'time':
					var $hourSelector = $customerCustomFieldRow.find('.customer-custom-field-value-input.hour');
					$hourSelector.attr('name', userCustomField.unique_id + "[hour]");
					Flits.dateTimeOptionGenerate(00, 23, $hourSelector);
					var $minuteSelector = $customerCustomFieldRow.find('.customer-custom-field-value-input.minute');
					$minuteSelector.attr('name', userCustomField.unique_id + "[minute]");
					Flits.dateTimeOptionGenerate(00, 59, $minuteSelector);
					$customerCustomFieldRow.find('select.customer-custom-field-value-input option[value=""]').prop('selected', true);
					$customerCustomFieldRow.find('select.customer-custom-field-value-input option[value=""]').attr('selected', true);
					$customerCustomFieldRow.find('select.customer-custom-field-value-input').val('');
					break;
				case 'file':
					if(typeof userCustomField.file_extensions !== 'undefined') {
						$customerCustomFieldRow.find('.customer-custom-field-value-input[type="file"]').attr('accept', userCustomField.file_extensions.toString())
					}
					if(typeof userCustomField.upload_button_text !== 'undefined') {
						$customerCustomFieldRow.find('.file-upload-button').html(userCustomField.upload_button_text)
					}
					if(typeof userCustomField.placeholder !== 'undefined') {
						$customerCustomFieldRow.find('.file-name-label').html(userCustomField.placeholder).attr('data-file-label', userCustomField.placeholder)
					}
					$customerCustomFieldRow.find('.customer-custom-field-value-input[type!="hidden"]').attr('name', userCustomField.unique_id);
					$customerCustomFieldRow.find('.customer-custom-field-value-input[type="hidden"]').attr('name', userCustomField.unique_id + '_file_status');
					break;
				default:
					if(typeof userCustomField.placeholder !== 'undefined' && userCustomField.placeholder != null && userCustomField.placeholder != '') {
						$customerCustomFieldRow.find('.customer-custom-field-value-input').attr('placeholder', userCustomField.placeholder)
					} else {
						if(location.pathname == '/account/register') {
							$customerCustomFieldRow.find('.customer-custom-field-value-input').attr('placeholder', userCustomField.title)
						}
					}
					$customerCustomFieldRow.find('.customer-custom-field-value-input').attr('name', userCustomField.unique_id);
					break
			}
			if(typeof userCustomField.description !== 'undefined' && userCustomField.description != null) {
				$customerCustomFieldRow.find('.customer-custom-field-description-text').html(userCustomField.description)
			} else {
				$customerCustomFieldRow.find('.customer-custom-field-description').addClass('flits-hide')
			}
			if(typeof userCustomField.is_required !== 'undefined' && userCustomField.is_required) {
				Flits("form[action='/account']").removeAttr('novalidate');
				$customerCustomFieldRow.find('input[type!="hidden"],textarea, select').attr('required', 'required');
				$customerCustomFieldRow.attr('data-field-required', 'required');
				if(typeof userCustomField.required_error_message !== 'undefined') {
					$customerCustomFieldRow.find('.customer-custom-field-required-error-message').html(userCustomField.required_error_message)
				}
			} else {
				$customerCustomFieldRow.find('.customer-custom-field-required-error-message').addClass('flits-hide')
			}
			$customerCustomFieldRow.find('.customer-custom-field-title').html(userCustomField.title);
			$customerCustomFieldRow.removeClass('customer-custom-field-row-clone');
			Flits.dispatchEvent('Flits:customFields:AfterFieldAppend', {
				customerCustomFieldRow: $customerCustomFieldRow,
				index: index
			})
		},
		setCustomerCustomFieldsDeatils: function(setCustomerCustomFieldsValue) {
			var userCustomFields = Flits.customFields.settings.userCustomFields;
			if(userCustomFields.length > 0) {
				Flits.customFields.settings.buttonElement = Flits.customFieldsTemplate.buttonElement();
				Flits(Flits.customFields.settings.loadingHtml).insertBefore(Flits.customFields.settings.buttonElement);
				Flits.dispatchEvent('Flits:customFields:BeforeAllFieldsAppend');
				userCustomFields.forEach((function(userCustomField, index) {
					Flits.setCustomFieldsList(userCustomField, index)
				}));
				Flits('.custom-fields-loading').addClass('flits-hide');
				Flits('.customer-custom-field-row').removeClass('flits-hide');
				Flits.dispatchEvent('Flits:customFields:AfterAllFieldsAppend');
				if(setCustomerCustomFieldsValue) {
					Flits.setCustomerCustomFieldsValue();
					Flits.dispatchEvent('Flits:customFields:CustomerAllFieldsValuesSet')
				}
			}
		},
		getFieldAjax: function() {
			var currentPage = window.location.pathname.split("/").pop();
			Flits.ajax({
				method: "GET",
				url: Flits.customFields.settings.getCustomFieldsURL,
				data: {
					currentPage: currentPage,
					token: Flits.token
				}
			}).done((function(resp) {
				if(resp.status) {
					Flits.customFields.settings.userCustomFields = resp.userCustomFields;
					Flits.setCustomerCustomFieldsDeatils(false)
				} else {}
			}))
		},
		removeItemLocalStorage: function(key) {
			if(localStorage.getItem(Flits.localStorageVar) != null) {
				var existing = JSON.parse(localStorage.getItem(Flits.localStorageVar));
				if(typeof existing[key] !== 'undefined') {
					delete existing[key]
				}
				return localStorage.setItem(Flits.localStorageVar, JSON.stringify(existing))
			}
		}
	});
	if(Flits.Metafields.IS_CUSTOM_FIELDS_ENABLE && Flits.Metafields.IS_CUSTOM_FIELDS_ENABLE == 1) {
		switch(location.pathname) {
			case window.flits_route_account_url + '/register':
				Flits.removeItemLocalStorage(Flits.customFields.settings.localStorageKeyName);
				Flits.getcustomFieldsAsset();
				break;
			case window.flits_route_account_url:
				Flits.getcustomFieldsAsset();
				Flits.setCustomFieldValueAjax();
				break;
			default:
				Flits.setCustomFieldValueAjax();
				break
		}
		Flits(document).on('Flits:customFields:AssetLoaded', (function(event) {
			Flits(Flits.customFieldsTemplate.cssStyle).appendTo("head");
			Flits.customFields.settings.htmlStructure = Flits.customFieldsTemplate.htmlStructure;
			if(location.pathname == '/account/register') {
				Flits.customFieldsRegisterPage()
			} else {
				Flits.customFieldsAccountPage()
			}
		}))
	}
})(Flits);